interface Props {
  className?: string;
}

export default function GalleryIcon({className}: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26 2H12V16H26V2ZM12 0C10.8954 0 10 0.89543 10 2V16C10 17.1046 10.8954 18 12 18H26C27.1046 18 28 17.1046 28 16V2C28 0.895431 27.1046 0 26 0H12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 20V7H7V20C7 20.5523 7.44772 21 8 21H21V23H8C6.34315 23 5 21.6569 5 20Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 25V12H2V25C2 25.5523 2.44772 26 3 26H16V28H3C1.34315 28 0 26.6569 0 25Z"
        fill="currentColor"
      />
      <path d="M24 13H14L16 7L18 11L21 6L24 13Z" fill="currentColor" />
    </svg>
  );
}
